import { render, staticRenderFns } from "./ScaleFormSet.vue?vue&type=template&id=736bd2af&scoped=true"
import script from "./ScaleFormSet.vue?vue&type=script&lang=js"
export * from "./ScaleFormSet.vue?vue&type=script&lang=js"
import style0 from "./ScaleFormSet.vue?vue&type=style&index=0&id=736bd2af&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "736bd2af",
  null
  
)

export default component.exports